/**
 * Persist the user's theme choice to their profile (PATCH /me/theme). The
 * ThemeProvider handles the *local* apply + localStorage; this just writes the
 * choice through to the DB so it follows the user across devices.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CurrentUser, ThemePreference } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

export function useUpdateThemePreference() {
  const qc = useQueryClient();
  return useMutation<CurrentUser, Error, ThemePreference>({
    mutationFn: (theme_preference) =>
      apiCall<CurrentUser>('/me/theme', {
        method: 'PATCH',
        body: { theme_preference },
      }),
    onSuccess: (user) => {
      // Keep every ['me', mode, mockRole] cache entry in step with the saved
      // value so the provider's reconcile sees no drift.
      qc.setQueriesData<CurrentUser>({ queryKey: ['me'] }, (old) =>
        old ? { ...old, theme_preference: user.theme_preference } : old,
      );
    },
  });
}
